import { apiConfig } from "./config";

export const raychatApi = {
  updateId: async (raychatId: any) => {
    const response = await apiConfig.patch(
      `/api/front/chef/set-goftino-id/${raychatId}`
    );
    return response;
  },
};

